<template>
  <div>
    <!--<div>发送</div>-->
  </div>
</template>

<script type="text/ecmascript-6">
import * as get from '@/api/components/pushMessage/pushMessage.js'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      websock: null
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    ...mapGetters(['token'])
  },
  created() {
    // 判断是否登录状态
    if (this.userInfo.userId) {
      get.getPush({ userId: this.userInfo.userId }).then(res => {
        if (res.result != 0) {
          this.$notify({
            onClick: this.jumpClick,
            position: 'bottom-right',
            dangerouslyUseHTMLString: true, // 设置为自定义布局
            message: `<strong style='cursor: pointer'>有<i>${res.result}</i>条新消息</strong>`
          })
        }
      }).catch(error => {
        console.log(error)
      })
    // 开启websocket
    // this.initWebSocket()
    }
  },
  mounted() {

  },
  methods: {
    initWebSocket() { // 初始化weosocket
      // const token = this.token
      // this.websock = new WebSocket('ws://192.168.9.141:8181/webSocketServer', [token])
      // this.websock.onopen = this.websocketonopen
      // this.websock.onerror = this.websocketonerror
      // this.websock.onmessage = this.websocketonmessage
      // this.websock.onclose = this.websocketclose
      // console.log(this.websock, this.token)
    },
    sendClick() {
      this.websocketsend('<input value="2g"></input>')
    },
    // 链接成功
    websocketonopen() {
      // console.log('WebSocket连接成功')
    },
    // 链接失败
    websocketonerror(e) { // 错误
      // console.log(e)
      // console.log('WebSocket连接发生错误')
    },
    // 长链接状态
    websocketonmessage(e) { // 数据接收
      this.$notify({
        title: '推送标题',
        onClick: this.jumpClick,
        position: 'bottom-right',
        dangerouslyUseHTMLString: true, // 设置为自定义布局
        message: `<strong>这是 <i>HTML</i> 片段</strong>`
      })
    },

    websocketsend(agentData) { // 数据发送
      this.websock.send(agentData)
    },
    // 关闭链接
    websocketclose(e) { // 关闭
      console.log(e)
    },
    jumpClick() {
      this.$router.push({
        name: 'NewsNotice'
      })
    }
  }
}
</script>

<style scoped lang='scss'>
  /deep/.el-notification.right{
    cursor: pointer;
  }
</style>
